import React from "react";
import "./footer.css";
import Config from "../../config";

function Footer({ configData }) {
  return (
    <div className="footer">
      <h5 className="footerText">
        ©{" "}
        {configData && configData.copyright_year
          ? configData.copyright_year
          : Config?.copyrightYear}{" "}
        Radisys |{" "}
        <a
          href={Config?.privacyPolicy}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "#ffffff" }}
        >
          Privacy Policy
        </a>{" "}
        <a
          href={Config?.TermsofService}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "#ffffff" }}
        >
          | Terms of Service
        </a>
      </h5>
    </div>
  );
}

export default Footer;
